module.exports = __webpack_public_path__ + "static/media/logMenuArrowActive.895d29dc.svg";